import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Modal } from '@/@bothrs-ui/web/components/modal/Modal'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'

import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type CloseQuestionnaireModalProps = InheritableModalProps & {
  onConfirm: () => void
}

const CloseAmendFlowModal = ({ onConfirm, onClose, ...props }: CloseQuestionnaireModalProps) => {
  const theme = useTheme()

  return (
    <Modal {...props}>
      <FlexColumn alignContent='center'>
        <FontAwesomeIcon icon={['fal', 'question-circle']} fontSize={24} />

        <Margin mt={theme.UI.Spacing.Space5} />

        <H3 textAlign='center' color={theme.Colors.Neutrals.Darkest}>
          {t({
            id: 'questionnaire.reconfirm.modal.close.title',
            comment: 'Modal title',
            message: 'Je wijzingen zijn nog niet opgeslagen',
          })}
        </H3>

        <P
          type='BodyLargeRegular'
          textAlign='center'
          color={theme.Colors.Neutrals.Darker}
          style={{ marginBottom: theme.UI.Spacing.Space6 }}
        >
          {t({
            id: 'questionnaire.reconfirm.modal.close.body',
            comment: 'Modal body',
            message: 'Als je dit scherm sluit, gaan je laatste aanpassingen verloren.',
          })}
        </P>

        <Button variant='Primary' onClick={onConfirm}>
          {t({
            id: 'questionnaire.reconfirm.modal.close.primary',
            comment: 'Modal primary button',
            message: 'Stoppen zonder opslaan',
          })}
        </Button>
        <Margin mt={theme.UI.Spacing.Space2} />
        <Button variant='Tertiary' onClick={onClose}>
          {t({
            id: 'questionnaire.reconfirm.modal.close.secondary',
            comment: 'Modal secondary button',
            message: 'Verder aanpassen',
          })}
        </Button>
      </FlexColumn>
    </Modal>
  )
}

export { CloseAmendFlowModal }
